import { useQuery, gql, type QueryResult } from '@apollo/react-hooks';
import { getModel } from '#/graphql/queries';
import type { GetModelQuery } from '#/graphql/types';

export const GET_MODEL = gql(getModel);

const useModelQuery = (id?: string) => {
  const query: QueryResult<GetModelQuery> = useQuery(GET_MODEL, {
    variables: { id },
    fetchPolicy: 'cache-and-network',
  });

  return query;
};

export default useModelQuery;
